export default __webpack_public_path__ + "img/32e56c0a16a96891a70dd66b719c5589.svg";